// main.js
document.addEventListener('DOMContentLoaded', function () {

  /* ---------------------------
     Header helpers
     --------------------------- */
  // Auto-close mobile nav when a link is clicked
  document.querySelectorAll('#mobileNav .mobile-nav-link').forEach(link => {
    link.addEventListener('click', () => {
      const mobileNav = document.getElementById('mobileNav');
      if (mobileNav && mobileNav.classList.contains('show')) {
        const bsCollapse = bootstrap.Collapse.getInstance(mobileNav) || new bootstrap.Collapse(mobileNav);
        bsCollapse.hide();
      }
    });
  });

  // Add scrolled class to header
  (function headerScroll() {
    const header = document.querySelector('.site-header');
    if (!header) return;
    function onScroll() {
      if (window.scrollY > 60) header.classList.add('scrolled');
      else header.classList.remove('scrolled');
    }
    onScroll();
    window.addEventListener('scroll', onScroll);
  })();


  /* ---------------------------
     Swiper gallery + thumbnail handling
     --------------------------- */
  if (typeof Swiper !== 'undefined') {
    const thumbSwiper = new Swiper('.product-thumb-swiper', {
      spaceBetween: 12,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesProgress: true,
      breakpoints: {
        0: { slidesPerView:6 },
        576: { slidesPerView: 6 },
        992: { slidesPerView: 6 }
      }
    });

    const mainSwiper = new Swiper('.product-main-swiper', {
      spaceBetween: 10,
      navigation: {
        nextEl: '.product-main-swiper .swiper-button-next',
        prevEl: '.product-main-swiper .swiper-button-prev'
      },
      thumbs: { swiper: thumbSwiper },
      loop: false
    });

    // Keep thumbnail active class in sync
    function updateThumbActive(index) {
      document.querySelectorAll('.product-thumb-swiper .thumb').forEach((t, i) => {
        t.classList.toggle('thumb-active', i === index);
      });
    }

    mainSwiper.on('slideChange', () => updateThumbActive(mainSwiper.realIndex));

    // Clicking a thumbnail jumps main and sets active
    document.querySelectorAll('.product-thumb-swiper .thumb').forEach((el, idx) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        mainSwiper.slideTo(idx);
        updateThumbActive(idx);
      });

      // keyboard accessibility
      el.setAttribute('tabindex', '0');
      el.addEventListener('keydown', (ev) => {
        if (ev.key === 'Enter' || ev.key === ' ') {
          ev.preventDefault();
          el.click();
        }
      });
    });

    // initialize active
    updateThumbActive(mainSwiper.realIndex);
  } else {
    // Fallback: if Swiper not loaded, simple thumbnail click -> swap main img
    const thumbs = document.querySelectorAll('.product-thumb-swiper .thumb img');
    const mainImage = document.querySelector('.product-gallery .main-image');
    if (thumbs && thumbs.length && mainImage) {
      thumbs.forEach((t, idx) => {
        t.addEventListener('click', (e) => {
          e.preventDefault();
          const full = t.getAttribute('data-full') || t.src;
          if (!full) return;
          // preload
          const img = new Image();
          img.onload = () => { mainImage.src = full; };
          img.src = full;

          // set active class visually
          thumbs.forEach(x => x.classList.remove('thumb-active'));
          t.classList.add('thumb-active');
        });
      });
    }
  }

  /* ---------------------------
     Bundle card selection & CTA update
     --------------------------- */
  (function bundleSelection() {
    const bundleCards = document.querySelectorAll('.bundle-card');
    const ctaBtn = document.getElementById('ctaBtn');

    if (!bundleCards || bundleCards.length === 0) return;

    function selectBundle(card) {
      bundleCards.forEach(c => c.classList.remove('selected'));
      card.classList.add('selected');

      // demo: update CTA with selected price (data-price)
      const price = card.getAttribute('data-price');
      if (price && ctaBtn) {
        ctaBtn.textContent = `TRY DERMACYL RISK-FREE → $${price}`;
      }
    }

    bundleCards.forEach(card => {
      card.addEventListener('click', () => selectBundle(card));
      card.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectBundle(card);
        }
      });
    });

    // initialize CTA text based on preselected card
    const initially = document.querySelector('.bundle-card.selected') || bundleCards[0];
    if (initially) selectBundle(initially);
  })();

});




// Testimonials Swiper init (add to assets/js/main.js)
document.addEventListener('DOMContentLoaded', function () {
  if (typeof Swiper === 'undefined') return;

  new Swiper('.testimonials-swiper', {
    slidesPerView: 1,
    spaceBetween: 18,
    loop: false,
    grabCursor: true,
    pagination: {
      el: '.testimonials-swiper .swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.testimonials-swiper .swiper-button-next',
      prevEl: '.testimonials-swiper .swiper-button-prev',
    },
    breakpoints: {
      576: { slidesPerView: 1.2, spaceBetween: 14 },   // slightly show next card
      768: { slidesPerView: 2, spaceBetween: 16 },
      992: { slidesPerView: 3, spaceBetween: 18 },
      1200: { slidesPerView: 4, spaceBetween: 20 }
    },
    a11y: true,
    keyboard: { enabled: true, onlyInViewport: true },
    touchRatio: 1,
    // Optional: enable autoplay (uncomment if desired)
    // autoplay: { delay: 4500, disableOnInteraction: true }
  });
});




// -----------------------------
// Steps thumbnails: click to swap large image (and keyboard accessible)
// Requires HTML thumbnails: <img class="steps-thumb" data-full="path/to/large.jpg" src="path/to/thumb.jpg">
// and large image: <img class="steps-large" src="...">
// -----------------------------
(function stepsThumbSwap() {
  document.addEventListener('DOMContentLoaded', () => {
    const large = document.querySelector('.steps-large');
    const thumbs = Array.from(document.querySelectorAll('.steps-thumb'));

    if (!large || thumbs.length === 0) return;

    // helper to set active thumb
    function setActive(index) {
      thumbs.forEach((t, i) => {
        t.classList.toggle('thumb-active', i === index);
        t.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    thumbs.forEach((thumb, idx) => {
      // make focusable
      thumb.setAttribute('tabindex', '0');
      thumb.style.cursor = 'pointer';

      const fullSrc = thumb.dataset.full || thumb.src;

      thumb.addEventListener('click', (e) => {
        e.preventDefault();
        // small fade while loading
        large.style.transition = 'opacity .2s ease';
        large.style.opacity = 0.2;

        const img = new Image();
        img.onload = () => {
          large.src = fullSrc;
          large.style.opacity = 1;
        };
        img.src = fullSrc;

        setActive(idx);
      });

      // keyboard accessible (Enter/Space)
      thumb.addEventListener('keydown', (ev) => {
        if (ev.key === 'Enter' || ev.key === ' ') {
          ev.preventDefault();
          thumb.click();
        }
      });
    });

    // initialize active (first thumb)
    setActive(0);
  });
})();




// FAQ accordion behavior (accessible)
// - Only one item open at a time (toggle)
// - Keyboard: Enter/Space toggles, Arrow Up/Down navigates between questions
(function faqAccordion() {
  document.addEventListener('DOMContentLoaded', () => {
    const faqWrap = document.querySelector('.faq-wrap');
    if (!faqWrap) return;

    const items = Array.from(faqWrap.querySelectorAll('.faq-item'));
    const buttons = items.map(i => i.querySelector('.faq-q'));

    // Ensure each button has an icon container for +/- and friendly aria
    buttons.forEach(btn => {
      // If no .faq-icon inside button, create one at the end of the button
      if (!btn.querySelector('.faq-icon')) {
        const icon = document.createElement('span');
        icon.className = 'faq-icon';
        // visually hide from screen readers (icon is decorative)
        icon.setAttribute('aria-hidden', 'true');
        btn.appendChild(icon);
      }
    });

    // Helper to set icon text for a specific button
    function setIcon(btn, isOpen) {
      const icon = btn.querySelector('.faq-icon');
      if (!icon) return;
      icon.textContent = isOpen ? '−' : '+'; // minus when open, plus when closed
      icon.classList.toggle('open', !!isOpen);
    }

    function closeAll(exceptIndex = -1) {
      items.forEach((it, idx) => {
        const btn = buttons[idx];
        const panel = it.querySelector('.faq-a');

        if (idx === exceptIndex) {
          it.classList.add('open');
          btn.setAttribute('aria-expanded', 'true');
          setIcon(btn, true);
          // If you use CSS transitions with max-height, ensure panel has the right styles in CSS
        } else {
          it.classList.remove('open');
          btn.setAttribute('aria-expanded', 'false');
          setIcon(btn, false);
        }
      });
    }

    // initial state: open the first item that has .open class, else none
    const initialOpenIdx = items.findIndex(it => it.classList.contains('open'));
    if (initialOpenIdx >= 0) {
      closeAll(initialOpenIdx);
    } else {
      closeAll(-1);
    }

    // click handlers and keyboard support
    buttons.forEach((btn, idx) => {
      btn.addEventListener('click', (e) => {
        const isOpen = items[idx].classList.contains('open');
        if (isOpen) {
          // close it
          items[idx].classList.remove('open');
          btn.setAttribute('aria-expanded', 'false');
          setIcon(btn, false);
        } else {
          // open this and close others
          closeAll(idx);
          // focus remains on button
        }
      });

      // keyboard navigation & toggle
      btn.addEventListener('keydown', (ev) => {
        if (ev.key === 'Enter' || ev.key === ' ') {
          ev.preventDefault();
          btn.click();
        } else if (ev.key === 'ArrowDown') {
          ev.preventDefault();
          const next = (idx + 1) % buttons.length;
          buttons[next].focus();
        } else if (ev.key === 'ArrowUp') {
          ev.preventDefault();
          const prev = (idx - 1 + buttons.length) % buttons.length;
          buttons[prev].focus();
        } else if (ev.key === 'Home') {
          ev.preventDefault();
          buttons[0].focus();
        } else if (ev.key === 'End') {
          ev.preventDefault();
          buttons[buttons.length - 1].focus();
        }
      });
    });

    // If you want clicking outside to close all, uncomment:
    // document.addEventListener('click', (e) => {
    //   if (!faqWrap.contains(e.target)) closeAll(-1);
    // });

  });
})();




// Testimonial slider: auto-advance every 5s with pause on hover/focus
(function testimonialSlider() {
  document.addEventListener('DOMContentLoaded', () => {
    const slider = document.querySelector('.testimonial-slider');
    if (!slider) return;

    const slides = Array.from(slider.querySelectorAll('.slide'));
    const indicatorWrap = slider.querySelector('.test-indicators');
    if (!slides.length) return;

    let current = 0;
    let interval = null;
    const delay = 3000; // 5 seconds

    // create indicators
    slides.forEach((s, i) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.setAttribute('aria-label', `Show testimonial ${i+1}`);
      btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      btn.dataset.index = i;
      btn.addEventListener('click', () => {
        show(i);
        restartInterval();
      });
      indicatorWrap.appendChild(btn);
    });

    const indicators = Array.from(indicatorWrap.querySelectorAll('button'));

    function show(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      slides.forEach((s, i) => {
        s.setAttribute('aria-hidden', i === index ? 'false' : 'true');
      });
      indicators.forEach((b, i) => b.setAttribute('aria-selected', i === index ? 'true' : 'false'));
      current = index;
    }

    function next() { show(current + 1); }
    function startInterval() {
      if (interval) return;
      interval = setInterval(next, delay);
    }
    function stopInterval() {
      if (!interval) return;
      clearInterval(interval);
      interval = null;
    }
    function restartInterval() {
      stopInterval();
      startInterval();
    }

    // pause on hover / focus
    slider.addEventListener('mouseenter', stopInterval);
    slider.addEventListener('mouseleave', startInterval);
    slider.addEventListener('focusin', stopInterval);
    slider.addEventListener('focusout', startInterval);

    // keyboard navigation
    slider.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        show(current - 1);
        restartInterval();
      } else if (e.key === 'ArrowRight') {
        show(current + 1);
        restartInterval();
      }
    });

    // initialize
    slides.forEach((s, i) => {
      // set initial aria-hidden if not done
      s.setAttribute('aria-hidden', i === 0 ? 'false' : 'true');
    });
    startInterval();
  });
})();



document.addEventListener("DOMContentLoaded", function () {
  const toggle = document.getElementById("menuToggle");
  const drawer = document.getElementById("mobileDrawer");
  const backdrop = document.getElementById("drawerBackdrop");
  const closeBtn = document.getElementById("closeDrawer");

  function openDrawer() {
    drawer.classList.add("active");
    backdrop.classList.add("active");
    document.body.style.overflow = "hidden";
    // update aria
    drawer.setAttribute("aria-hidden", "false");
    toggle.setAttribute("aria-expanded", "true");
  }

  function closeDrawer() {
    drawer.classList.remove("active");
    backdrop.classList.remove("active");
    document.body.style.overflow = "";
    // update aria
    drawer.setAttribute("aria-hidden", "true");
    toggle.setAttribute("aria-expanded", "false");
  }

  toggle.addEventListener("click", openDrawer);
  closeBtn.addEventListener("click", closeDrawer);
  backdrop.addEventListener("click", closeDrawer);

  // --- NEW: close drawer when clicking a link inside it ---
  // Use event delegation so dynamically added links also work.
  drawer.addEventListener("click", function (e) {
    const link = e.target.closest("a[href]");
    if (!link) return;

    // Only handle internal-page links (hash) or same-page anchors:
    // - href starts with '#' OR href without protocol & host (relative anchor)
    const href = link.getAttribute("href") || "";
    const isHash = href.startsWith("#");
    const isSamePageAnchor = (() => {
      try {
        // Create a temporary URL to compare origin + pathname
        const tmp = new URL(href, location.href);
        return tmp.origin === location.origin && tmp.pathname === location.pathname && tmp.hash;
      } catch (err) {
        return false;
      }
    })();

    // Close the drawer for any in-drawer link that navigates the same page,
    // or for any link if you want the drawer to close for all links on mobile.
    if (isHash || isSamePageAnchor) {
      // Allow native scroll to the hash to run; close drawer on next frame so the browser can act
      requestAnimationFrame(() => closeDrawer());
      // If you want to scroll smoothly after closing, uncomment next lines:
      // if (href.startsWith("#")) {
      //   const target = document.querySelector(href);
      //   if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
      // }
    } else {
      // If the link goes to another page, also close the drawer
      // (so user leaves with drawer closed)
      requestAnimationFrame(() => closeDrawer());
    }
  });

  // Close drawer on ESC for accessibility
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && drawer.classList.contains("active")) {
      closeDrawer();
    }
  });

  // Optional: close drawer on window resize to desktop widths
  window.addEventListener("resize", function () {
    if (window.innerWidth >= 992 && drawer.classList.contains("active")) {
      closeDrawer();
    }
  });
});



(function ingredientAccordion() {
  document.addEventListener('DOMContentLoaded', () => {
    const card = document.querySelector('.ingredients-card');
    if (!card) return;

    // select rows (your provided HTML)
    const rows = Array.from(card.querySelectorAll('.ingredient-row'));

    

    // initialize each row: hide desc (CSS does initial), create .ing-sub if not exist, set aria attributes
    rows.forEach((row, index) => {
      const body = row.querySelector('.ing-body');
      if (!body) return;
      const desc = body.querySelector('.ing-desc');
      const source = body.querySelector('.ing-source');
      const title = body.querySelector('.ing-name');

      // create subtitle element if missing
      let sub = body.querySelector('.ing-sub');
      if (!sub) {
        sub = document.createElement('div');
        sub.className = 'ing-sub';
        // generate from desc text
        const descText = desc ? desc.textContent.trim() : '';
       
        // insert right after title
        title.insertAdjacentElement('afterend', sub);
      }

      // make the row keyboard accessible: set tabindex and role
      row.setAttribute('tabindex', '0');
      row.setAttribute('role', 'button');
      row.setAttribute('aria-expanded', 'false');

      // ensure desc has aria-hidden initially
      if (desc) desc.setAttribute('aria-hidden', 'true');

      // click handler toggles this one and closes others
      function toggle() {
        const isOpen = row.classList.contains('open');
        if (isOpen) {
          closeRow(row);
        } else {
          // close others
          rows.forEach(r => {
            if (r !== row) closeRow(r);
          });
          openRow(row);
        }
      }

      // keyboard support: Enter / Space to toggle
      row.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle();
        } else if (e.key === 'ArrowDown') {
          e.preventDefault();
          const next = rows[(index + 1) % rows.length];
          next.focus();
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          const prev = rows[(index - 1 + rows.length) % rows.length];
          prev.focus();
        }
      });

      // click
      row.addEventListener('click', (e) => {
        // avoid click when source link clicked
        const isLink = e.target.closest('a');
        if (isLink) return;
        toggle();
      });
    });

    // open & close helpers (manage aria, classes and animate max-height)
    function openRow(row) {
      const desc = row.querySelector('.ing-desc');
      const source = row.querySelector('.ing-source');
      row.classList.add('open');
      row.setAttribute('aria-expanded', 'true');
      if (desc) {
        desc.setAttribute('aria-hidden', 'false');
        // animate max-height to content's scrollHeight
        const target = desc.scrollHeight;
        desc.style.maxHeight = target + 'px';
        desc.style.paddingBottom = '6px';
      }
      if (source) {
        source.style.opacity = '1';
        source.style.transform = 'translateY(0)';
      }
    }

    function closeRow(row) {
      const desc = row.querySelector('.ing-desc');
      const source = row.querySelector('.ing-source');
      row.classList.remove('open');
      row.setAttribute('aria-expanded', 'false');
      if (desc) {
        // collapse smoothly
        desc.style.maxHeight = '0px';
        desc.style.paddingBottom = '0px';
        desc.setAttribute('aria-hidden', 'true');
      }
      if (source) {
        source.style.opacity = '0';
        source.style.transform = 'translateY(6px)';
      }
    }

    // Optional: open first row initially? If you want, uncomment:
    // if (rows[0]) openRow(rows[0]);

  });
})();





document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.querySelector('.compare-wrapper');
  if (!wrapper) return;

  const table = wrapper.querySelector('.compare-table');
  if (!table) return;

  const mobileUI = wrapper.querySelector('.mobile-compare');
  const select = mobileUI.querySelector('#mobileCompareSelect');
  const list = mobileUI.querySelector('#mobileCompareList');

  // Read headers (product names from thead th, second+)
  const theadThs = Array.from(table.querySelectorAll('thead th'));
  // first th is Feature; next are product columns
  const productHeaders = theadThs.slice(1).map((th, idx) => {
    // if inner image exists use alt or fallback to text
    const img = th.querySelector('img');
    const name = (img && img.alt) ? img.alt.trim() : (th.textContent || '').trim() || `Product ${idx+1}`;
    return { name, index: idx + 1 };
  });

  // Build rows array by reading tbody rows; for each row store feature text and cell texts/html per product column index
  const tbodyRows = Array.from(table.querySelectorAll('tbody tr'));
  const features = tbodyRows.map((tr) => {
    const tds = Array.from(tr.querySelectorAll('td'));
    const featureText = (tds[0] && tds[0].textContent.trim()) || '';
    const productCells = tds.slice(1).map(td => {
      // for tick/x we want to preserve a standardized "check"/"x" or price text
      const check = td.querySelector('.icon-check');
      const x = td.querySelector('.icon-x');
      if (check) return { type: 'check', html: td.innerHTML };
      if (x) return { type: 'x', html: td.innerHTML };
      // otherwise treat as text/price
      const text = td.textContent.trim();
      return { type: 'text', text, html: td.innerHTML };
    });
    return { feature: featureText, cells: productCells };
  });

  // Populate select options (exclude first column's own Dermacyl at index 0 because left is always Dermacyl)
  // We will allow selecting any other product *including* first? Per requirement left should always be Dermacyl, so options are productHeaders[1...]
  const leftProduct = productHeaders[0]; // Dermacyl assumed first
  const rightOptions = productHeaders.slice(1); // others

  // If there are no rightOptions, hide mobile UI
  if (!rightOptions.length) {
    mobileUI.style.display = 'none';
    return;
  }

  // fill select
  select.innerHTML = '';
  rightOptions.forEach((p, i) => {
    const opt = document.createElement('option');
    opt.value = String(i + 1); // index in rightOptions
    opt.textContent = p.name;
    select.appendChild(opt);
  });

  // Build mobile rows UI function
  function renderMobileCompare(rightIndexInOptions) {
    list.innerHTML = '';
    // iterate features
    features.forEach((f) => {
      // create row
      const row = document.createElement('div');
      row.className = 'mobile-row';
      // feature cell
      const feat = document.createElement('div');
      feat.className = 'mobile-feature';
      feat.textContent = f.feature;
      row.appendChild(feat);

      // left Dermacyl cell: f.cells[0]
      const leftCell = document.createElement('div');
      leftCell.className = 'mobile-value mobile-left';
      const leftData = f.cells[0];
      if (!leftData) {
        leftCell.textContent = '';
      } else if (leftData.type === 'check') {
        const span = document.createElement('span');
        span.className = 'icon icon-check';
        leftCell.appendChild(span);
      } else if (leftData.type === 'x') {
        const span = document.createElement('span');
        span.className = 'icon icon-x';
        leftCell.appendChild(span);
      } else {
        // text/price
        leftCell.innerHTML = `<div class="mobile-price">${leftData.text}</div>`;
      }
      row.appendChild(leftCell);

      // right selected product: index mapping
      const rightGlobalIndex = rightOptions[rightIndexInOptions].index - 1; // productHeaders index -> productCells index
      // But we stored cells as arrays starting at product column 1 = index 0 in cells array
      // rightOptions[i].index corresponded to table column index; however in features.cells array, cells[0] is first product col.
      // We want right product's cell relative index:
      const rightCellData = f.cells[rightOptions[rightIndexInOptions].index - 1];

      const rightCell = document.createElement('div');
      rightCell.className = 'mobile-value mobile-right';
      if (!rightCellData) {
        rightCell.textContent = '';
      } else if (rightCellData.type === 'check') {
        const span = document.createElement('span');
        span.className = 'icon icon-check';
        rightCell.appendChild(span);
      } else if (rightCellData.type === 'x') {
        const span = document.createElement('span');
        span.className = 'icon icon-x';
        rightCell.appendChild(span);
      } else {
        rightCell.innerHTML = `<div class="mobile-price">${rightCellData.text}</div>`;
      }
      row.appendChild(rightCell);

      list.appendChild(row);
    });
  }

  // initialize default selection (first option)
  select.selectedIndex = 0;
  renderMobileCompare(0);

  // wire select change
  select.addEventListener('change', function () {
    renderMobileCompare(Number(this.value) - 1);
  });

  // Make mobile UI visible only when CSS shows it (script sets aria-hidden accordingly)
  function updateMobileVisibility() {
    const mobileShown = window.matchMedia('(max-width: 991.98px)').matches;
    mobileUI.setAttribute('aria-hidden', mobileShown ? 'false' : 'true');
  }
  updateMobileVisibility();
  window.addEventListener('resize', updateMobileVisibility);

});
